var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',_vm._b({staticClass:"footer-button"},'base-link',_vm.button,false),[_vm._v(" "+_vm._s(_vm.button.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }